import React,{useEffect} from 'react'

import News from '../Home/Components/News/News'

import './Terms.scss'



const Terms = () => {

    useEffect(() => {
        window.scrollTo(0, 0);

    }, [])

    return (
        <>

            <div className="boo">
                Terms And Conditions :
            </div>
            <div className="main_term">
                <div className="title">
                    Terms or Condition
                </div>
                <div className="main_para">
                    <p>
                        Flux Group, Inc., (“<span>Flux</span>,” “<span>we</span>,” “<span>our</span>,” or “<span>us</span>,” as used here, will refer to Flux Group, Inc. and its parents, subsidiaries, and affiliates) respects your privacy (“<span>you</span>”). We recognize the importance of your personally identifiable information and any other information that could reasonably relate to you (“<span>Personal Information</span>”).
                    </p>


                    <div className="list">
                        <div className="title">
                            This Privacy Policy includes the following sections:
                        </div>
                        <p> 1. Information We Collect </p>
                        <p> 2. Unsubscribing From Email </p>
                        <p> 3. How We Use Personal Information </p>
                        <p> 4. How We Disclose Personal Information </p>
                        <p> 5. Your Access to and Control Over Information </p>
                    </div>
                    <div className="special">
                        <div className="heading">1. Trademarks </div>
                        <p>
                            We collect Personal Information both directly from you, and from third parties. Where applicable, we indicate whether and why you must provide us with your Personal Information, as well as the consequences of failing to do so. If you do not provide Personal Information when requested, you may not be able to benefit from our service if that information is necessary to provide you with the service or if we are legally required to collect it.
                        </p>
                    </div>
                    <div className="special">
                        <div className="heading">2. Other Intellectual Property Rights  </div>
                        <p>

                            This website and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof), (together the “Content”) are owned by Flux, its licensors, or other providers of such material, and are protected by U.S., Canadian, and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.

                            You hereby acknowledge that the Content is protected by all copyright, trade-mark, and other applicable intellectual property laws.  Your use of the website does not grant or transfer to you any ownership or other rights in the Content, and except as expressly provided, nothing herein or within the website shall be construed as conferring on you or any other person any license under any of Flux’s or any third party’s intellectual property rights, including, without limitation, any right to download, display, reproduce, distribute, modify, edit, alter or enhance any of the Content in any manner whatsoever other than as expressly set out herein. Any rights not expressly granted to you in these Terms of Use are expressly reserved by Flux. For greater certainty, you agree that you will not take any action that is inconsistent with Flux ownership of the website and/or Flux ownership of, or any third party’s ownership of, any Content.
                        </p>
                    </div>

                    <div className="special">
                        <div className="heading">
                            Your Permission to use the Website
                        </div>
                        <div className="list_main">
                            <p>
                                These terms permit you to use our website for your personal, non-commercial use only. You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our website or any Content, except as follows:

                            </p>
                            <li>
                                Your computer may temporarily store copies of such materials in RAM incidental to your accessing and viewing those materials.</li>
                            <li>You may store files that are automatically cached by your web browser for display enhancement purposes.</li>
                            <li>You may print or download one copy of a reasonable number of pages of our website for your own personal, non-commercial use and not for further reproduction, publication, or distribution.</li>

                        </div>
                    </div>
                </div>
            </div>
            <News />

        </>

    )
}

export default Terms
